import React from "react";
import ReactApexChart from "react-apexcharts";

function LineChart({ chartOpt }) {
  return (
    <div id="chart">
      <ReactApexChart
        options={chartOpt.options}
        series={chartOpt.series}
        height={350}
        type="area"
      />

      {/* <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="line"
        height={350}
      /> */}
    </div>
  );
}

export default LineChart;
